import React from 'react';
import "./left_side.scss"

const LeftSide = () => {
  return (
    <div className='hfgh'>
  <div className="jhdf">
<a href="mailto:connect.aromagupta@gmail.com" target="_blank ">connect.aromagupta@gmail.com</a>

  </div>
    </div>
  );
}

export default LeftSide;
